<template>
  <el-dialog
    id="apPauseDialog"
    :title="$t('customAlert.extension.extensionEvaluated')"
    :visible.sync="showLocal"
    :width="dialogWidth"
  >
    <div class="apPauseContent">
      <i18n path="customAlert.extension.footer">
        <template #email>
          Support@GlobalCoachGroup.com
        </template>
      </i18n>

      <div class="actionWrap">
        <el-button
          type="primary"
          round
          @click="showLocal = false"
        >
          {{ $t('common.close') }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import dialog from '@/mixins/dialog';

export default {
  name: 'ApPauseDialog',

  mixins: [
    dialog,
  ],
};
</script>

<style lang="scss">
  #apPauseDialog {
    .el-dialog__body {
      padding: 10px 20px;
    }

    .apPauseContent {
      word-break: break-word;
    }

    .actionWrap {
      text-align: center;
      margin: 20px 0 10px;
    }
  }
</style>
